import { MKTX_DEALER_LIST_MODES } from '../../Constants/AppConstants';

const normalizeMktxDealers = (value) => [...new Set(
  (Array.isArray(value) ? value : String(value || '').split(','))
    .map((dealer) => String(dealer).trim()).filter(Boolean)
)];

// ALL is an explicit choice. Named selections stay named, even if every option was picked.
export const mktxDealersForSubmit = (value) => {
  const dealers = normalizeMktxDealers(value);
  return dealers.includes('ALL') ? 'ALL' : dealers.sort().join(',');
};

export const defaultMktxDealers = (value, mode) => {
  const dealers = normalizeMktxDealers(value);
  return !dealers.length && mode === MKTX_DEALER_LIST_MODES.INCLUDE_AT_LEAST
    ? ['ALL'] : dealers;
};

export const selectMktxDealers = (values, reason, details) => {
  const dealers = normalizeMktxDealers(values);
  if (reason === 'clear') return [];
  if (details?.option === 'ALL') return dealers.includes('ALL') ? ['ALL'] : [];
  return dealers.filter((dealer) => dealer !== 'ALL');
};
